import React, { Fragment } from 'react';
import { CSSTransition } from "react-transition-group";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import Icon from "../../../../icons/Icon";
import StoreButton from "../../../../uq-ui/components/store-button";
import Div100vh from "../../../../uq-ui/components/div-100";

class LayoutComponentsModalGoApp extends React.PureComponent {

  static propTypes = {
    onHide: PropTypes.func,
    show: PropTypes.bool
  };

  onClosePressed = () => {
    this.props.onHide();
  };

  _renderCloseButton() {
    return (
      <div className={styles.closeBtnWrap}>
        <button type="button"
                onClick={this.onClosePressed}
                className={styles.closeBtn}>
          <Icon name="ModalClose" width="20px" height="20px"/>
        </button>
      </div>
    )
  }

  render() {
    return (
      <Fragment>
        <CSSTransition
          in={this.props.show}
          timeout={400}
          classNames="modalSlideUp"
          unmountOnExit
          mountOnEnter>
          <Div100vh className={styles.container} style={{minHeight: '100rvh'}}>
            {this._renderCloseButton()}
            <div className={styles.inner}>
              <div className={`${styles.title} font-title`}>{ this.props.t('title') }</div>
              <div className={styles.benefits}>{ this.props.t('subtitle') }</div>
              <StoreButton />
            </div>
          </Div100vh>
        </CSSTransition>
      </Fragment>
    );
  }
}

export default withTranslation('cmp-modal-goapp')(LayoutComponentsModalGoApp);


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/modal-goapp/index.jsx